const FastlyAssetPath = (url) => {
  // If URL is protocol-relative URL
  // We should add https: so links will not break when applying withPrefix modification
  if (url.startsWith("//")) {
    url = `https:${url}`
  }

  return url.replace(/assets.(ctfassets.net|contentful.com)/, "www.fastly.com/cassets")
}

export default FastlyAssetPath
